import { render, staticRenderFns } from "./spaceImageEstados.vue?vue&type=template&id=46bc5078&scoped=true"
import script from "./spaceImageEstados.vue?vue&type=script&lang=js"
export * from "./spaceImageEstados.vue?vue&type=script&lang=js"
import style0 from "./spaceImageEstados.vue?vue&type=style&index=0&id=46bc5078&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bc5078",
  null
  
)

export default component.exports